import { useContext } from 'react';
import NotificacionesFinanzasContext from '../context/NotificacionesFinanzas/NotificacionesFinanzasContext';

export const useNotificacionesFinanzas = () => {
  const context = useContext(NotificacionesFinanzasContext);
  return { ...context };
};

export default useNotificacionesFinanzas;
